import { Component, WritableSignal, effect, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '../../../services/Auth/auth.service';
import { Router } from '@angular/router';
import { SpinnerComponent } from "../../../common/spinner/spinner.component";
import { ToggleDarkComponent } from "../../../common/toggle-dark/toggle-dark.component";
import { NgClass } from '@angular/common';
import { ThemeService } from '../../../services/theme/theme.service';

@Component({
  selector: 'auth',
  standalone: true,
  imports: [ReactiveFormsModule, SpinnerComponent, ToggleDarkComponent, NgClass],
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.scss'
})
export class AuthComponent {
  loading: WritableSignal<boolean> = signal(false);
  showPassword: boolean = false;
  error: string = '';
  form!: FormGroup;
  isDark!: boolean;
  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private theme: ThemeService,
  ){
    this.initForm()
    authService.isAuthenticated() && this.loginSuccess();

    effect(() => {
      this.loading() ? this.form.disable() : this.form.enable();
      this.isDark = theme.isDark();
    });
  }

  initForm(){
    this.form = this.fb.group({
      email: ['', [
        Validators.required,
        Validators.email
      ]],
      password: ['', Validators.required],
    });
  }

  submit(){
    const email = this.form.get('email')?.value;
    const password = this.form.get('password')?.value;
    this.error = ''
    this.loading.set(true);

    this.authService.login(email, password).subscribe({
      next: () => {
        this.loginSuccess();
      },
      error: () => this.loginFailed()

    });
  }

  loginSuccess(){
    this.router.navigate(['admin']);
  }

  loginFailed(){
    this.loading.set(false);
    this.error = 'Login Failed. Invalid Username / Password.';
    this.form.enable()
  }

}
